import { AxiosInstance } from "axios"

export interface LoginRequest {
    identity: string
    password: string
}

const authApi = (apiInstance: AxiosInstance) => {
    const login = async (credentials: LoginRequest): Promise<any> => {
        const loggedInUserInfo = apiInstance.post("/parcel-hub-users/login", credentials)
        return loggedInUserInfo
    }

    return {
        login
    }
}

export default authApi
